import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Global error handler that prevents information disclosure by sanitizing errors
 * shown to end users in production mode.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  
  handleError(error: any): void {
    // Silently handle all errors - do not log anything to console
    // You can integrate with a logging service here to send errors to your backend
    // this.loggingService.logError(error);
    
    // Do not expose error details to the user or console
    return;
  }
}